import {decorate, observable} from "mobx";
import Api from "../util/api";

/** Message d'erreur lisible : celui du serveur s'il existe (validation, refus métier), sinon un message générique. */
export function messageErreur(e) {
    const donnees = e?.response?.data;
    if (donnees?.errors) {
        return Object.values(donnees.errors).map(m => m[0]).join(" ");
    }

    return donnees?.message ?? "Une erreur est survenue, merci de réessayer.";
}

export default class SmsStore {

    // Historique
    messages = observable([]);
    currentPage = 1;
    lastPage = 1;
    limit = 30;
    statut = "";
    compteurs = {};
    statuts = {};
    dernierContact = null; // dernière interrogation du téléphone (date ISO 8601), null s'il ne s'est jamais connecté

    // Modèles
    modeles = observable([]);
    variables = {};

    constructor(rootStore) {
        this.rootStore = rootStore;
        this.api = new Api();
    }

    /** silencieux : rafraîchissement automatique, sans voile de chargement ni message d'erreur. */
    async getHistory(silencieux = false) {
        if (!silencieux) {
            this.rootStore.savedDatasStore.setLoading(true);
        }
        try {
            const reponse = await this.api.sms.getHistory(this.currentPage, this.limit, this.statut);
            this.messages.replace(reponse.data);
            this.currentPage = reponse.current_page;
            this.lastPage = reponse.last_page;
            this.compteurs = reponse.compteurs ?? {};
            this.statuts = reponse.statuts ?? {};
            this.dernierContact = reponse.dernier_contact ?? null;
        } catch (e) {
            if (!silencieux) {
                this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            }
        }
        if (!silencieux) {
            this.rootStore.savedDatasStore.setLoading(false);
        }
    }

    async resend(id) {
        try {
            await this.api.sms.resend(id);
            this.rootStore.notificationStore.setNotification("SMS remis en file : le téléphone va le renvoyer.", "success");
            await this.getHistory();
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
        }
    }

    async getTemplates() {
        try {
            const reponse = await this.api.sms.getTemplates();
            this.modeles.replace(reponse.modeles);
            this.variables = reponse.variables ?? {};
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
        }
    }

    /** Renvoie le modèle enregistré, ou null (l'erreur est alors affichée). */
    async saveTemplate(data) {
        try {
            const modele = await this.api.sms.saveTemplate(data);
            this.rootStore.notificationStore.setNotification("Modèle enregistré", "success");
            await this.getTemplates();
            return modele;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            return null;
        }
    }

    async deleteTemplate(id) {
        try {
            await this.api.sms.deleteTemplate(id);
            this.rootStore.notificationStore.setNotification("Modèle supprimé", "success");
            await this.getTemplates();
            return true;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            return false;
        }
    }

    /** Aperçu du SMS final (sans rien envoyer) ; null en cas d'erreur. */
    async preview(data) {
        try {
            return await this.api.sms.preview(data);
        } catch (e) {
            return null;
        }
    }

    /** Met le SMS en file ; renvoie le SMS créé, ou null (l'erreur est alors affichée). */
    async send(data) {
        try {
            const sms = await this.api.sms.send(data);
            this.rootStore.notificationStore.setNotification("SMS envoyé vers " + sms.numero + " : il part dans quelques secondes.", "success");
            return sms;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            return null;
        }
    }
}

decorate(SmsStore, {
    currentPage: observable,
    lastPage: observable,
    statut: observable,
    compteurs: observable,
    statuts: observable,
    dernierContact: observable,
    variables: observable,
});
